import { render, staticRenderFns } from "./v-radio.vue?vue&type=template&id=203c48ff"
import script from "./v-radio.vue?vue&type=script&lang=js"
export * from "./v-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203c48ff')) {
      api.createRecord('203c48ff', component.options)
    } else {
      api.reload('203c48ff', component.options)
    }
    module.hot.accept("./v-radio.vue?vue&type=template&id=203c48ff", function () {
      api.rerender('203c48ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/radio/v-radio.vue"
export default component.exports